import "./Contact.css";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Join = () => {
  const notify = () => {
    toast.success(`Su mensaje fue enviado con exito`);
  };

  useEffect(() => {
    document
      .querySelectorAll(".writing :is(input , textarea)")
      .forEach((writinginput) => {
        writinginput.addEventListener("input", () => {
          if (writinginput.value.trim() !== "") {
            writinginput.classList.add("has-text");
          } else {
            writinginput.classList.remove("has-text");
          }
        });
      });
  }, []);

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_r4ur1or",
        "template_7vxvwfl",
        form.current,
        "JdR1Dx17dUXAVDmQd"
      )
      .then(
        (result) => {
          notify();
          form.current.reset();
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <>
      <div className="container-co" id="contact">
        <h2 className="title-co">Contacto</h2>
        <div>
          <span className="title-j">CONTACTANOS!</span>
        </div>
        <div className="title-start">
          <p>Escribinos tu consulta</p>
        </div>
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <div className="entryarea writing input1-margintop">
            <input type="text" name="from_name" />
            <label className="labelline">Nombre</label>
          </div>
          <div className="entryarea writing input1-margintop">
            <input type="text" name="user_tel" />
            <label className="labelline">Telefono / WhatsApp</label>
          </div>
          <div className="entryarea writing">
            <input type="email" name="user_email" />
            <label className="labelline">Email</label>
          </div>
          <div className="entryarea writing">
            <textarea name="message" className="text-j" />
            <label className="labelline-message">Mensaje</label>
          </div>
          <input className="btn btn-j" type="submit" value="ENVIAR" />
        </form>
      </div>
      <ToastContainer />
    </>
  );
};

export default Join;
